import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const AddUserOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fillRule="evenodd" clipRule="evenodd" fill={color}>
      <Path d="M9.23 7.37a2.83 2.83 0 1 1 5.66 0 2.83 2.83 0 0 1-5.66 0Zm2.83-4.43a4.43 4.43 0 0 0-2.666 7.968c-3.613.773-6.384 3.836-6.384 7.542v.78a.8.8 0 0 0 1.6 0v-.78c0-3.322 2.915-6.13 6.57-6.13h1.66c1.033 0 2.009.224 2.873.626a.8.8 0 0 0 .674-1.452 8.29 8.29 0 0 0-1.683-.57A4.43 4.43 0 0 0 12.06 2.94ZM18.25 14.76a.8.8 0 1 0-1.6 0v1.89h-1.89a.8.8 0 0 0 0 1.6h1.89v1.9a.8.8 0 0 0 1.6 0v-1.9h1.89a.8.8 0 0 0 0-1.6h-1.89v-1.89Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default AddUserOutlined
